





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import CategoryApi from "@/module/device/CategoryApi";
import Category, {CategoryType} from "@/model/Category";

@Component({
  components: {},
})
export default class CategorySelect extends Vue {

  private categoryApi = Container.get(CategoryApi)

  @Prop()
  private categoryId?: number

  @Prop()
  private isCustom?: boolean

  private lastCategoryId?: number

  private EMPTY_CATEGORY_ID = undefined

  private get _categoryId() {
    return this.categoryId
  }

  private set _categoryId(value: number | undefined) {
    this.$emit('update:categoryId', value)
  }

  private CategoryType = CategoryType
  private categoryType = CategoryType.STANDARD
  private categories: Array<Category> = []

  private async created() {
    this.refresh()
  }

  async refresh() {
    if (this.isCustom)
      this.categoryType = CategoryType.CUSTOM
    else this.categoryType = CategoryType.STANDARD
    this.categories = await this.categoryApi.list()
  }

  private handleCategoryTypeChange() {
    switch (this.categoryType) {
      case CategoryType.STANDARD:
        this.$emit('update:categoryId', this.lastCategoryId)
        break
      case CategoryType.CUSTOM:
        this.lastCategoryId = this.categoryId
        this.$emit('update:categoryId', undefined)
        break
    }
  }
}
